import ky from 'ky';

export const CLIENT_ENDPOINT = process.env.NEXT_PUBLIC_CLIENT_ENDPOINT || 'https://kuxy.kr'
export const SERVER_ENDPOINT = process.env.NEXT_PUBLIC_SERVER_ENDPOINT || 'https://api.kuxy.kr'
export const STATIC_ENDPOINT = process.env.NEXT_PUBLIC_STATIC_ENDPOINT || 'https://static.kuxy.kr'

export const apiInstance = ky.create({
  prefixUrl: SERVER_ENDPOINT,
  credentials: 'include',
  timeout: 120000,
  retry: { limit: 2, delay: attemptCount => 2 ** attemptCount * 1000 },
  hooks: {
    afterResponse: [
			async (_request, _options, response) => {
        if (!response.ok) {
          const errMessage = await response.text()
          throw new Error(errMessage)
        }
			}
    ]
  },
})

export const API_ENDPOINT = {
  blogs: {
    getBlogs: async (tag: string = '') => {
      const response = await apiInstance.get(`blogs`, { searchParams: { tag } })
      const data = await response.json() as any
      return data
    },
    getBlog: async (id: string) => {
      const response = await apiInstance.get(`blogs/${id}`)
      const data = await response.json() as any
      return data
    },
    getTags: async () => {
      const response = await apiInstance.get(`blogs/tags`)
      const data = await response.json() as any
      return data
    },
  },
  inquery: {
    sendServiceRequestInquery: async (data: Object) => await apiInstance.post(`inquery/service`, data),
    sendFeatureRequestInquery: async (content: string) => await apiInstance.post(`inquery/new-feature`, { json: { content }}),
    sendErrorReport: async (content: any) => await apiInstance.post(`inquery/error`, { json: { content }}),
  }
}